import { Stack, styled } from '@mui/material';

export const Container = styled(Stack)(({ theme }) => ({
  height: 'calc(100vh - 64px)',
  width: theme.spacing(80),
  gap: theme.spacing(3),
  justifySelf: 'center',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: theme.spacing(60),
    padding: theme.spacing(1),
  },
}));
